import React from "react";
import PropTypes from "prop-types";
import { translate as t } from "infrastructure/translate/localization";
import reviewEmployeesToDelete from "usecases/employees/review-employees-to-delete";

import { Typography } from "@material-ui/core";
import Modal from "../../Modal";
import Stepper from "../../Modal/components/Stepper";
import CurrentMonthConsumptions from "./steps/CurrentMonthConsumptions";
import RemainingBalance from "./steps/RemainingBalance";
import PendingPayments from "./steps/PendingPayments";
import DeliveredBalances from "./steps/DeliveredBalances";

export default function DeleteEmployeesModal({
  currentStep,
  employees,
  isLoading,
  target,
  ...rest
}) {
  const steps = [
    {
      title: t("employees-section.current-month-consumptions"),
      content: CurrentMonthConsumptions,
      tooltip: t("employees-section.current-month-consumptions-tooltip"),
    },
    {
      title: t("employees-section.remainingBalance.title"),
      content: RemainingBalance,
      tooltip: t("employees-section.remainingBalance.tooltip"),
    },
    {
      title: t("employees-section.pending-payments"),
      content: PendingPayments,
      tooltip: t("employees-section.pending-payments-tooltip"),
    },
    {
      title: t("employees-section.delivered-balance"),
      content: DeliveredBalances,
      tooltip: t("employees-section.delivered-balance-tooltip"),
    },
  ];

  const ActiveContent = steps[currentStep].content;

  const Content = () => (
    <>
      <Stepper
        steps={steps.map((step, index) => ({
          ...step,
          active: currentStep >= index,
          isCurrent: currentStep === index,
          action: () =>
            reviewEmployeesToDelete({
              employees,
              currentStep: index,
            }),
        }))}
        isAProcess
      />
      <ActiveContent
        employees={employees}
        content={steps[currentStep]}
        currentStep={currentStep}
        isLoading={isLoading}
        target={target}
        {...rest}
      />
    </>
  );

  return (
    <>
      {target === "page-container" ? (
        <main className="section">
          <div className="section-container">
            <Typography variant="h6">
              {t("employees-section.delete-employees")}
            </Typography>
            <Content />
          </div>
        </main>
      ) : (
        <Modal title={t("employees-section.delete-employees")}>
          <Content />
        </Modal>
      )}
    </>
  );
}

DeleteEmployeesModal.defaultProps = {
  currentStep: 0,
  isLoading: false,
};

DeleteEmployeesModal.propTypes = {
  currentStep: PropTypes.number,
  employees: PropTypes.array.isRequired,
  isLoading: PropTypes.bool,
};
